export default {_name:'card.list',module:'Field',view:'Element/Card/List',options:{xs:12,icon:{name:'device'},cardWidth:'auto',template:'Element/Card'}}